import React, { useState, useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/Dashboard.css";
import { Cross } from "lucide-react";
import { useUser, useOrganization } from "@clerk/clerk-react";
import { useApiFetch, errorMessage, toastError } from "src/lib/api";
import { Button } from "../components/ui/button";
import DashboardFilterBar from "../components/common/DashboardFilterBar";
import WidgetSkeleton from "../components/common/WidgetSkeleton";
import { format, startOfDay, endOfDay, startOfMonth } from "date-fns";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import TemperatureVictron from "../components/common/TemperatureVictron";
import { CameraStatus } from "../components/common/CameraStatus";
import { ACLoad } from "../components/common/ACLoad";
import { AlertTriangle, LayoutDashboard } from "lucide-react";
import {FanStatus} from "../components/common/FanStatus";
import BatteryVoltage from "../components/common/BatteryVoltage";
import FanStateGraph from "../components/common/FanStateGraph";
import CameraStateGraph from "../components/common/CameraStateGraph";
import HistoricTemperatures from "../components/common/HistoricTemperatures";
import HistoricConsumptions from "../components/common/HistoricConsumptions";
import { createSwapy } from 'swapy'
import { CardDescription, CardHeader, CardTitle, } from "../components/ui/card";
import html2canvas from "html2canvas";
import MyEditor from "../components/common/TextEditor"
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
// [tutorial disabled] import { driver } from "driver.js";
import "react-toastify/dist/ReactToastify.css";
// [tutorial disabled] import "driver.js/dist/driver.css";

const frameworks = [
  {
    value: "Device1",
    label: "Device1",
  },
  {
    value: "Device2",
    label: "Device2",
  },
  {
    value: "Device3",
    label: "Device3",
  },
  {
    value: "Device4",
    label: "Device4",
  },
  {
    value: "Device5",
    label: "Device5",
  },
];

const DashboardVictron = ({ type }) => {
  /* Date range: defaults to the current month so far (1st of the month -> today) */
  const [startDate, setStartDate] = useState(() => startOfMonth(new Date()));
  const [endDate, setEndDate] = useState(() => endOfDay(new Date()));
  /* console.log("StartDate: ", startDate, "EndDate: ", endDate); */
  const [data, setData] = useState(null);
  const [devicesAvailable, setDevicesAvailable] = useState(false);
  const [devicesLoading, setDevicesLoading] = useState(true);
  /* MonitorID */
  const [value, setValue] = React.useState("");
  const [victronId, setVictronId] = React.useState("");
  const [appliedVictronId, setAppliedVictronId] = useState(""); // Device whose data is displayed (set on search)
const { organization } = useOrganization();
  {/* Dashboard stats*/}
  const [devices, setDevices] = useState([]);
  const [product, setProduct] = useState("");
  const [role, setRole] = useState("member") 
  const [fanState, setFanState] = useState(null);
  const [cameraState, setCameraState] = useState(null);
  const [loading, setLoading] = useState(true); // Estado de carga
  const [temperature, setTemperature] = useState("0.0 ºC"); // Define temperatures values
  const [historicBatteryVoltages, setHistoricBatteryVoltages] = useState([]); // Define voltages values
  const [historicFanState, setHistoricFanState] = useState([]);
  const [historicCameraState, setHistoricCameraState] = useState([]); 
  const [historicTemperatures, setHistoricTemperatures] = useState([]); 
  const [historicConsumptions, setHistoricConsumptions] = useState([]); 
  const [acLoad, setACload] = useState("0 W"); // Define ACLoad values
  const [retention, setRetention] = useState(null); // { oldestTimestamp, newestTimestamp, maxEntries }
  const [searchError, setSearchError] = useState(null); // Message of the last failed search (modal)
  /* Progressive loading: the layout appears as soon as a search starts and each group of
     widgets shows a placeholder until its own request finishes (both requests run in parallel) */
  const [displayedVictronId, setDisplayedVictronId] = useState(""); // Device whose layout is shown
  const [searching, setSearching] = useState(false);
  const [liveLoading, setLiveLoading] = useState(false); // Live value cards
  const [historyLoading, setHistoryLoading] = useState(false); // History charts
  const [appliedRange, setAppliedRange] = useState(null); // { start, end } of the displayed history
  const searchIdRef = useRef(0); // Ignores responses of a search replaced by a newer one
  const lastShownVictronIdRef = useRef(""); // Last search that fully succeeded (restored on error)

  const COMPONENTS_MAP_GRID1 = {
    BatteryVoltage: (props) => <BatteryVoltage historicBatteryVoltages={props.historicBatteryVoltages} startDate={props.startDate} endDate={props.endDate}/>,
    FanStateGraph: (props) => <FanStateGraph historicFanState={props.historicFanState} startDate={props.startDate} endDate={props.endDate}/>,
    CameraStateGraph: (props) => <CameraStateGraph historicCameraState={props.historicCameraState} startDate={props.startDate} endDate={props.endDate}/>,
    HistoricTemperatures: (props) => <HistoricTemperatures historicTemperatures={props.historicTemperatures} startDate={props.startDate} endDate={props.endDate}/>,
    HistoricConsumptions: (props) => <HistoricConsumptions historicConsumptions={props.historicConsumptions} startDate={props.startDate} endDate={props.endDate}/>,
  };

  const COMPONENTS_MAP_GRID2 = {
    FanStatus: (props) => <FanStatus state={props.fanState}/>,
    CameraStatus: (props) => <CameraStatus state={props.cameraState}/>,
    ACLoad: (props) => <ACLoad acLoad={props.acLoad} />,
    TemperatureVictron: (props) => <TemperatureVictron temperature={props.temperature} />,
  };

  const orgId = organization?.id;

  // [tutorial disabled] const disableTutorial = async () => {
    // [tutorial disabled] try {
      // [tutorial disabled] await apiFetch("/auth/disable-tutorial", { method: "POST" });
    // [tutorial disabled] } catch (error) {
      // [tutorial disabled] console.error("Error disabling tutorial:", error);
    // [tutorial disabled] }
  // [tutorial disabled] };

  {/* Token & tole */}
  const { user } = useUser();
  const navigate = useNavigate(); // Hook para redirección

  const apiFetch = useApiFetch(); // Shared request helper (src/lib/api.js): null on 401, throws on other errors

  // const role = user.organizationMemberships[0].role;

  // Esta función se invoca al pulsar el botón de lupa: es el único punto que carga datos
  const handleFilterClick = async () => {
    // console.log("HandleFilterClick with victronId:", victronId, "from", startDate, "to", endDate);
    if (!victronId) {
      toast.info("Select a device first");
      return;
    }
    if (!startDate || !endDate) {
      toast.info("Select a start and end date");
      return;
    }
    if (startOfDay(startDate) > endOfDay(endDate)) {
      toast.error("The start date must be before the end date");
      return;
    }

    const searchId = ++searchIdRef.current;
    const isCurrent = () => searchIdRef.current === searchId;
    const deviceChanged = victronId !== appliedVictronId;
    const range = { start: startOfDay(startDate), end: endOfDay(endDate) };

    setSearchError(null);
    setSearching(true);
    setDisplayedVictronId(victronId); // Layout with placeholders right away
    setHistoryLoading(true);
    if (deviceChanged) setLiveLoading(true);

    // Live values (cards) only when the device changed since the last search
    const liveRequest = !deviceChanged
      ? Promise.resolve()
      : apiFetch("/api/dashboard-victron", {
          method: "POST",
          body: { victronId: victronId },
        })
          .then((live) => {
            if (!live || !isCurrent()) return;
            const l = live?.deviceData?.[0] ?? {};
            setFanState(l.fanState ?? null);
            setCameraState(l.cameraState ?? null);
            setACload(l.acLoad ?? "");
            setTemperature(l.temperature ?? "");
            setAppliedVictronId(victronId);
          })
          .finally(() => {
            if (isCurrent()) setLiveLoading(false);
          });

    const historyRequest = apiFetch("/api/dashboardVictron-filter", {
      method: "POST",
      body: {
        victronId: victronId,
        startDate: range.start,
        endDate: range.end,
      },
    })
      .then((data) => {
        if (!data || !isCurrent()) return;
        const d = data?.deviceData?.[0] ?? {};
        setHistoricBatteryVoltages(d.historyBatteryVoltages ?? {});
        setHistoricFanState(d.historyFan ?? {});
        setHistoricCameraState(d.historyCamera ?? {});
        setHistoricTemperatures(d.historyTemperatures ?? {});
        setHistoricConsumptions(d.historyConsumptions ?? {});
        setRetention(data?.retention ?? null);
        setAppliedRange(range);
      })
      .finally(() => {
        if (isCurrent()) setHistoryLoading(false);
      });

    const results = await Promise.allSettled([liveRequest, historyRequest]);
    if (!isCurrent()) return;
    setSearching(false);

    const failure = results.find((r) => r.status === "rejected");
    if (failure) {
      console.error("Error fetching filtered dashboard data:", failure.reason);
      setSearchError(errorMessage(failure.reason, "Error loading the dashboard data"));
      // Back to what was shown before this search (or the empty state)
      setDisplayedVictronId(lastShownVictronIdRef.current);
    } else {
      lastShownVictronIdRef.current = victronId;
    }
  };

  const [gridMode, setGridMode] = useState(false); // Editor container status (displayed / hidden)
  {/* Editor creation */}
  const editorRef = useRef(null);
  {/* IMG add by users inside the Editor to export*/}
  const [insertedImage, setInsertedImage] = useState([]);

  const handleAddIMG = async (itemId) => {
    const element = document.getElementById(itemId);
    if (!element ) {
      console.warn(`Item with id: "${itemId}, not found"`);
      return;
    }
    const canvas = await html2canvas(element, { backgroundColor: "#fff" });
    const imageDataUrl = canvas.toDataURL("image/png");
    
    setInsertedImage(prev => [...prev, imageDataUrl]);
  };

  {/* Function that waits fro the dashboard to appear to apply swapy grids */}
  function waitForElement(selector, callback, isCancelled = () => false) {
    if (isCancelled()) return;
    const element = document.getElementById(selector);
    if (element) {
      callback(element);
    } else {
      setTimeout(() => waitForElement(selector, callback, isCancelled), 100);
    }
  }
  
  const [layoutSwapy1, setLayout1] = useState(null);
  const [layoutSwapy2, setLayout2] = useState(null);

  const showCharts = Boolean(displayedVictronId);

  // The selection (device / dates) differs from the data on screen: the user must press Search
  const sameDay = (a, b) => Boolean(a && b) && a.getTime() === b.getTime();
  const pendingSearch = !searching && Boolean(victronId) && Boolean(startDate) && Boolean(endDate) && (
    victronId !== displayedVictronId ||
    !appliedRange ||
    !sameDay(startOfDay(startDate), appliedRange.start) ||
    !sameDay(endOfDay(endDate), appliedRange.end)
  );

  {/* Create swapy grids once the layouts are loaded and the charts are shown, destroy them on cleanup */}
  useEffect(() => {
    if (!layoutSwapy1 || !layoutSwapy2 || !showCharts) return;

    let cancelled = false;
    const instances = [];

    ["swapyGrid1", "swapyGrid2"].forEach((gridId) => {
      waitForElement(gridId, (container) => {
        instances.push(createSwapy(container, { autoScrollOnDrag: true }));
      }, () => cancelled);
    });

    return () => {
      cancelled = true;
      instances.forEach((instance) => instance.destroy());
    };
  }, [layoutSwapy1, layoutSwapy2, gridMode, showCharts]);

  {/* Toogle drop area display */}
  const toggleDropGrid = () => {
    setGridMode(!gridMode); 
  };

  {/* Definning editor's area */}
  const EditorArea = () => {
    return (
      <div
        className="dropArea border-2 p-4 z-10 mt-10 position-absolute h-auto bg-[#000000bd] rounded-sm transition-all duration-1000 items-center align-middle"
        style={{ width: '98.5%', minHeight: '100%'}}
      >
        {/* Close editor icon X */}
        <div className="closeEditor absolute top-0 right-0 m-4 z-10">
            <Cross className="m-1 h-6 w-6 fill-[white] hover:fill-[#e2e8f0] rotate-45" onClick={toggleDropGrid}>
            </Cross>
        </div>

        {/* Editor container */}
        <div id="editorContainer" className="">       
          <div className="editor-container px-15 items-center">
            <CardHeader className="items-center pb-2">
                <CardTitle>Edit your file here!</CardTitle>
                <CardDescription></CardDescription>
            </CardHeader>
          </div>  
          <MyEditor insertedImage={insertedImage}/>
        </div>
      </div>
    );
  };

  useEffect(() => {
    /* if (!orgId) return; */

    const fetchData = async () => {
      setLoading(true);

      try {
        const data = await apiFetch("/api/dashboardVictron-default");
        if (!data) return;
        setDevices(data?.devices || []);
        setDevicesAvailable(true);

        // console.log("FetchData triggered");
        // console.log("FetchData with devices:", data?.devices);
        // console.log("FetchData with data:", data);
        // console.log("FetchData with victronId:", data?.victronId);
        
        setProduct(data?.product?.product);

        setRole(data?.role || "member")
        /* console.log("[DEBUG] Role set to:", data?.role || "member"); */
        
      } catch (error) {
        console.error("Error fetching devices:", error);
        toastError(error);
      } finally {
        setLoading(false);
        setDevicesLoading(false);
      }
    };

    fetchData();
  }, [orgId]);

  // [tutorial disabled] /* Display tour tutorial */
  // [tutorial disabled] useEffect(() => {
  // [tutorial disabled] if (!product || product === "") return;

  // [tutorial disabled] let intervalId = null;

  // [tutorial disabled] const checkForTutorialReady = () => {
    // [tutorial disabled] let step = localStorage.getItem("driver-tutorial-step");
    // [tutorial disabled] const el = document.querySelector(".filter-container");

    // [tutorial disabled] if (step === "dashboard-v2" && el) {
      // [tutorial disabled] clearInterval(intervalId); 
      // [tutorial disabled] startDriver(); 

      // [tutorial disabled] setTimeout(() => {
        // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);
      // [tutorial disabled] }, 1000);
    // [tutorial disabled] }
  // [tutorial disabled] };

  // [tutorial disabled] const startDriver = () => {
    // [tutorial disabled] const driverObj = driver({
      // [tutorial disabled] steps: [
        // [tutorial disabled] {
          // [tutorial disabled] element: ".filter-container",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Bar to filter devices by name or date",
            // [tutorial disabled] prevBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
            // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onPrevClick: () => {
              // [tutorial disabled] if(product === "both") {
                // [tutorial disabled] navigate("/dashboard");
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "dashboard-v1");
              // [tutorial disabled] } else {
                // [tutorial disabled] if( role === "admin") {
                  // [tutorial disabled] navigate("/deviceManager");
                  // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "device-manager");
                // [tutorial disabled] } else {
                  // [tutorial disabled] navigate("/detection");
                  // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "detections");
                // [tutorial disabled] }
              // [tutorial disabled] }
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onHighlighted: () => {
            // [tutorial disabled] const enablePrev = () => {
              // [tutorial disabled] const prevBtn = document.querySelector('.driver-popover-prev-btn');
              // [tutorial disabled] if (prevBtn) {
                // [tutorial disabled] prevBtn.removeAttribute("disabled");
                // [tutorial disabled] prevBtn.classList.remove('driver-popover-btn-disabled');
                // [tutorial disabled] clearInterval(retry); 
              // [tutorial disabled] }
            // [tutorial disabled] };

            // [tutorial disabled] const retry = setInterval(enablePrev, 100);
            // [tutorial disabled] setTimeout(() => clearInterval(retry), 1000);
          // [tutorial disabled] },
        // [tutorial disabled] },
        // [tutorial disabled] {
          // [tutorial disabled] element: "#swapyGrid2",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Grid that displays live data about temperature, consumption and the live status of the camera and fan of the device",
            // [tutorial disabled] prevBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
            // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
        // [tutorial disabled] },
        // [tutorial disabled] {
          // [tutorial disabled] element: "#swapyGrid1",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Battery Data",
            // [tutorial disabled] description: "Grid that displays a linear chart about the historic data of the voltages retrieved from the battery",
            // [tutorial disabled] prevBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
            // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
        // [tutorial disabled] },
        // [tutorial disabled] {
          // [tutorial disabled] element: "#save-button",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Save button for charts distribution",
            // [tutorial disabled] prevBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
            // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
        // [tutorial disabled] },
        // [tutorial disabled] /* {
          // [tutorial disabled] element: "#report",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Report file",
            // [tutorial disabled] description: "This section allows you to add unlimited charts to create a simple report within your notes",
            // [tutorial disabled] prevBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
            // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
          // [tutorial disabled] },
        // [tutorial disabled] }, */
        // [tutorial disabled] {
          // [tutorial disabled] element: "#adminVictron",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Access admin information",
            // [tutorial disabled] description: "This button allows you to access the VRM website to access more specific data about your devices",
            // [tutorial disabled] prevBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
            // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
        // [tutorial disabled] },
        // [tutorial disabled] {
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "End of tour",
            // [tutorial disabled] description: "The tutorial tour has been completed, enjoy your stay!",
            // [tutorial disabled] prevBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
            // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
            // [tutorial disabled] onNextClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
              // [tutorial disabled] driverObj.destroy();
            // [tutorial disabled] },
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
        // [tutorial disabled] },
      // [tutorial disabled] ],
    // [tutorial disabled] });

    // [tutorial disabled] driverObj.drive();
  // [tutorial disabled] };

  // [tutorial disabled] // Poll cada 300ms hasta que estén el paso y el elemento
  // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);

  // [tutorial disabled] // Limpieza del intervalo
  // [tutorial disabled] return () => {
    // [tutorial disabled] if (intervalId) clearInterval(intervalId);
  // [tutorial disabled] };
// [tutorial disabled] }, [product]);
  
  const getSwapyGridLayout = (gridId) => {
    const container = document.getElementById(gridId);
    const layout = [];

    if (!container) return layout;

    const items = container.querySelectorAll("[data-swapy-slot]");

    items.forEach((item) => {
      const slot = item.getAttribute("data-swapy-slot");
      const itemChild = item.querySelector("[data-swapy-item]");
      const itemAttr = itemChild?.getAttribute("data-swapy-item");
      const componentId = itemChild?.querySelector("div[id]")?.id;

      if (slot && itemAttr && componentId) {
        layout.push({
          slot,
          item: slot,
          componentId
        });
      }
    });
    return layout;
  };

  const fetchSavedLayout = async () => {
      try {
          const data = await apiFetch("/api/retrieve-layouts");

          const dashboardMagnetic = data?.layoutData?.[1]?.dashboardMagnetic;
          if (dashboardMagnetic) {
            const restoredLayout1 = {};
            (dashboardMagnetic.swapyGrid1 ?? []).forEach(({ slot, componentId }) => {
              restoredLayout1[slot] = componentId;
            });

            const restoredLayout2 = {};
            (dashboardMagnetic.swapyGrid2 ?? []).forEach(({ slot, componentId }) => {
              restoredLayout2[slot] = componentId;
            });

            setLayout1(restoredLayout1);

            setLayout2(restoredLayout2);

          }
        } catch (error) {
          console.error("Error retrieving layouts:", error);
          toastError(error);
        }
    };

  useEffect(() => {
    /* if (!orgId) return; */
    fetchSavedLayout();
  }, [/* orgId */]);

  const saveSwapyLayouts = async () => {
    setLoading(true);
    const layoutData = {
      swapyGrid2: getSwapyGridLayout("swapyGrid2"),
      swapyGrid1: getSwapyGridLayout("swapyGrid1"),
    };

    try {
      const data = await apiFetch("/api/save-layouts-magnetic", {
        method: "POST",
        body: { layout: layoutData },
      });
      if (!data) return;

      toast.success("Layout saved successfully!", {
          className: "mt-[50px]",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

    } catch (error) {
      console.error("Error saving layout:", error);
      toastError(error, "Error saving layout");
    } finally {
      setLoading(false);
    }
  };

  const retentionOldest = retention?.oldestTimestamp ? new Date(retention.oldestTimestamp) : null;
  const showRetentionNotice =
    retentionOldest && !isNaN(retentionOldest) && startDate && startDate < retentionOldest;

  const renderDynamicLayout1 = () => {
    if (!layoutSwapy1) return null;

      return Object.entries(layoutSwapy1).map(([slot, componentId]) => {
        const Component = COMPONENTS_MAP_GRID1[componentId];
        if (!Component) return null;

        return (
          <div key={slot} data-swapy-slot={slot}>
            <div data-swapy-item={slot}>
              <div id={componentId} className="m-2">
                {historyLoading || !appliedRange ? (
                  <WidgetSkeleton variant="chart" />
                ) : (
                <Component
                  historicBatteryVoltages={historicBatteryVoltages}
                  historicFanState={historicFanState}
                  historicCameraState={historicCameraState}
                  historicTemperatures={historicTemperatures}
                  historicConsumptions={historicConsumptions}
                  startDate={appliedRange.start}
                  endDate={appliedRange.end}
                />
                )}
                {/* <Button
                  variant="outline"
                  size="icon"
                  className="w-[40px] m-2"
                  onClick={() => handleAddIMG(componentId)}
                >
                  <Cross className="m-1 h-4 w-4" />
                </Button> */}
              </div>
            </div>
          </div>
        );
      });
  };

  const renderDynamicLayout2 = () => {
    if (!layoutSwapy2) return null;

      return Object.entries(layoutSwapy2).map(([slot, componentId]) => {
        const Component = COMPONENTS_MAP_GRID2[componentId];
        if (!Component) return null;

        return (
          <div key={slot} data-swapy-slot={slot}>
            <div data-swapy-item={slot}>
              <div id={componentId} className="m-2">
                {liveLoading ? (
                  <WidgetSkeleton variant="stat" />
                ) : (
                <Component
                  fanState={fanState}
                  cameraState={cameraState}
                  acLoad={acLoad}
                  temperature={temperature}
                />
                )}
                {/* <Button
                  variant="outline"
                  size="icon"
                  className="w-[40px] m-2"
                  onClick={() => handleAddIMG(componentId)}
                >
                  <Cross className="m-1 h-4 w-4" />
                </Button> */}
              </div>
            </div>
          </div>
        );
      });
  };

  return (
    <div>
      <div className="dashboard-container dashboard-page">
        {/* Report feature only available for admins */}
          { role === "admin" && (
            <div className="dashboard-admin-actions">
              {/* <Button variant="outline" size="icon" className="w-[180px] " onClick={toggleDropGrid} id="report">
                <p className="mt-3 ">Create a report</p>
                <ChevronRight className="m-1 h-6 w-6" />
              </Button>  */}

              <Button variant="outline" size="icon" className="w-[220px]" id="adminVictron" onClick={() =>
                  (window.location.href = `https://vrm.victronenergy.com/login`)
                }>
                <p className="mt-3 ">Access admin information</p>
              </Button>

                {gridMode && (
                  <EditorArea/>
                  
                )}
            </div>
          )} 

        <DashboardFilterBar
          devices={(Array.isArray(devices) ? devices : []).map((device) => ({ key: device.victronId ?? device.name, label: device.name }))}
          selected={value}
          onSelect={(name) => {
            setValue(name);
            const dev = devices.find((x) => x.name === name);
            if (dev) setVictronId(dev.victronId);
          }}
          devicesLoading={devicesLoading}
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
          onSearch={handleFilterClick}
          searching={searching}
          pending={pendingSearch}
          hasResults={showCharts}
        />
        {showCharts && showRetentionNotice && (
          <div className="mt-4 rounded-sm border border-yellow-400 bg-yellow-50 px-4 py-2 text-sm text-yellow-800" role="status">
            Data older than {format(retentionOldest, "PPP")} is no longer retained.
          </div>
        )}
        {showCharts ? (
          <div
            className={`swapy-grids grid
            gap-4`}
            style={{ paddingTop: "2rem" }}
          >  
            <div id={`${!gridMode ? "swapyGrid2" : undefined}`} className={`swapy-grid-1v2 swapy-stat-grid grid gap-4`}>
              { layoutSwapy2 && (
                  renderDynamicLayout2()
              )}
            </div>

            <div id={`${!gridMode ? "swapyGrid1" : undefined}`} className={`swapy-grid-1`}>
              { layoutSwapy1 && (
                  renderDynamicLayout1()
              )}
            </div>
          </div>
        ) : (
          <div className="dashboard-empty-state" role="status">
            <LayoutDashboard className="dashboard-empty-state-icon" aria-hidden="true" />
            {loading ? (
              <h3>Loading…</h3>
            ) : devicesAvailable && devices.length === 0 ? (
              <>
                <h3>No devices available</h3>
                <p>There are no devices linked to this organization yet.</p>
              </>
            ) : (
              <>
                <h3>Select a device to get started</h3>
                <p>Choose a device and a date range, then click the search button to load its data.</p>
              </>
            )}
          </div>
        )}

        {/* Save changes*/}
        <Button
          variant=""
          size="icon"
          className="w-[150px] m-2 fixed bottom-4 right-4 p-3"
          onClick={saveSwapyLayouts}
          disabled={!showCharts || loading || searching}
          id="save-button"
        >
          Save changes
        </Button>

      </div>
        <ToastContainer/>

        {/* Failed search: centered on top of the page, the only action is retrying.
            The technical error is only shown to admins. */}
        <Dialog
          open={!!searchError}
          onOpenChange={(isOpen) => {
            if (!isOpen) setSearchError(null);
          }}
        >
          <DialogContent className="dashboard-error-dialog">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <AlertTriangle className="h-5 w-5 text-red-600" aria-hidden="true" />
                Could not load the dashboard data
              </DialogTitle>
              <DialogDescription>
                Something went wrong while searching. Please try again.
              </DialogDescription>
            </DialogHeader>
            {role === "admin" && searchError && (
              <pre className="dashboard-error-details">{searchError}</pre>
            )}
            <DialogFooter>
              <Button onClick={handleFilterClick} disabled={searching}>
                {searching ? "Retrying…" : "Retry search"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
    </div>
  );
};

export default DashboardVictron;